import { GET_ATTRIBUTE_BY_CODE, REMOVE_ATTRIBUTES_FROM_STATE } from 'Store/Attribute/Attribute.action';

export const getInitialState = (state) => ({
    ...state,
    attributes: {}
});

export const AttributeReducer = (state = getInitialState(), action) => {
    const { attribute } = action;
    const { attributes } = state;

    switch (action.type) {
    case GET_ATTRIBUTE_BY_CODE:
        return {
            ...state,
            attributes: {
                ...attributes,
                [attribute.attribute_code]: attribute
            }
        };
    case REMOVE_ATTRIBUTES_FROM_STATE:
        return {
            ...state,
            attributes: {
            }
        }
    default:
        return state;
    }
};

export default AttributeReducer;
